import { Button, Drawer } from "antd";
import { useTranslation } from "react-i18next";

export default function FilterDrawer({
  open,
  closeHandler,
  clearFilter,
  submitFilter,
  children,
}) {
  const { t, i18n } = useTranslation();
  return (
    <Drawer
      open={open}
      onClose={closeHandler}
      styles={{
        header: {
          borderBottom: "none",
        },
        body: {
          padding: "0 24px",
        },
        footer: {
          display: "flex",
          alignItems: "center",
          gap: "8px",
          borderTop: "none",
        },
      }}
      placement={i18n.dir() === "rtl" ? "left" : "right"}
      width={300}
      footer={
        <>
          <Button
            className="flex-stretch"
            danger
            type="primary"
            onClick={clearFilter}
          >
            {t("common.reset")}
          </Button>
          <Button
            className="flex-stretch"
            type="primary"
            variant="filled"
            onClick={submitFilter}
          >
            {t("common.filter")}
          </Button>
        </>
      }
    >
      {children}
    </Drawer>
  );
}
